import { post, get } from '../request'
import { API_SUCCESS, API_FAILURE } from '~/helper/constant/api_status'
import ApiResponse from '~/model/response'

export const addAlumni = (data, token) => {
    return new Promise(function (resolve, reject) {
        try {
            post('alumni/add', token, data).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const searchAlumni = (data, token) => {
    return new Promise(function (resolve, reject) {
        try {
            post('alumni/search', token, data).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}
